import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, DELETE } from "const"
import { MtStudy } from "server/models"
import {
    PRM_STUDY,
    StoreType,
    addModal,
} from "client/store"
import { hasProjectAccess } from "client/utils"
import {
    Link,
    UserIcon,
    DateFormatter,
    TableColumn,
    Empty,
} from "client/components"

const Columns = () => {
    const baseRoute = useSelector((state: StoreType) => state.study.baseRoute)
    const studyList = useSelector((state: StoreType) => state.study.studyList)

    const projectSettings = useSelector((state: StoreType) => state.project.projectSettings)
    const accountSettings = useSelector((state: StoreType) => state.system.accountSettings)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const deleteAccess = hasProjectAccess(PRM_STUDY, DELETE)

    const { studyFields } = projectSettings.study.studyFieldsAssigned ? projectSettings.study : accountSettings.study

    const studyLink = (study: MtStudy, linkContent: any) => {
        const href = `${baseRoute}/${VIEW}/${study.id}`
        return (
            <Link
                href={href}
                onClick={() => dispatch(addModal({ url: href }))}
            >
                {linkContent}
            </Link>
        )
    }

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
            formatter: (study: MtStudy) => studyLink(study, study.id),
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "300px",
            formatter: (study: MtStudy) => studyLink(study, study.name),
        },
        {
            field: "description",
            header: lang.description,
            display: studyFields.description,
            cellMinWidth: "200px",
            cellMaxWidth: "300px",
        },
        {
            field: "dateStart",
            header: lang.dateStart,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
            formatter: (study: MtStudy) => <DateFormatter date={study.dateStart} showTime={false} />,
        },
        {
            field: "dateEnd",
            header: lang.dateEnd,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
            formatter: (study: MtStudy) => <DateFormatter date={study.dateEnd} showTime={false} />,
        },
        {
            field: "managerId",
            header: lang.manager,
            display: studyFields.manager,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
            formatter: (study: MtStudy) => {
                const user = userList[study.managerId]
                return <UserIcon user={user} size="sm" />
            },
        },
        {
            field: "systemStageId",
            header: lang.systemStage,
            display: studyFields.systemStage,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
            formatter: (study: MtStudy) => (study.systemStage ? study.systemStage.name : <Empty />),
        },
        {
            field: "statusId",
            header: lang.studyStatus,
            display: studyFields.studyStatus,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
            formatter: (study: MtStudy) => (study.status ? study.status.name : <Empty />),
        },
        {
            field: "location",
            header: lang.location,
            display: studyFields.location,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "300px",
        },
        {
            field: "site",
            header: lang.site,
            display: studyFields.site,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
        },
        {
            field: "plant",
            header: lang.plant,
            display: studyFields.plant,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
        },
        {
            field: "group",
            header: lang.group,
            display: studyFields.group,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
        },
        {
            field: "unit",
            header: lang.unit,
            display: studyFields.unit,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
        },
        {
            field: "subUnit",
            header: lang.subUnit,
            display: studyFields.subUnit,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
        },
        {
            field: "createdAt",
            header: lang.created,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
            formatter: (study: MtStudy) => <DateFormatter date={study.createdAt} />,
        },
    ]

    if (deleteAccess && Object.values(studyList).length > 1) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
